import React, { useMemo } from 'react';

import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';

import { WorkspaceProductType } from '../../models/Workspace';
import PaymentUtils from '../../utils/payment.utils';

export default ({ selectedPackage, userDetails, onUpdateSelectedPackage, discountData }) => {
  const isWhiteGlove = useMemo(() => [userDetails?.workspace?.productType].includes(WorkspaceProductType.whiteGlove.value), [userDetails]);

  const handleUpdateSelectedPackage = (_event, value) => {
    if (onUpdateSelectedPackage) onUpdateSelectedPackage(value);
  };

  const pricing = useMemo(() => {
    const price = {
      express: parseFloat(PaymentUtils.PACKAGE_EXPRESS_VIDEO_REPORT.plan.price),
      standard: parseFloat(PaymentUtils.PACKAGE_STANDARD_VIDEO_REPORT.plan.price),
    };

    // eslint-disable-next-line camelcase
    if (discountData?.percent_off) {
      price.express *= (100 - discountData.percent_off) / 100;
      price.standard *= (100 - discountData.percent_off) / 100;
    } else if (isWhiteGlove) {
      price.express = (price.express * 90) / 100;
      price.standard = (price.standard * 90) / 100;
    }

    if (`${price.express}`.includes('.')) price.express = price.express.toFixed(2);
    if (`${price.standard}`.includes('.')) price.standard = price.standard.toFixed(2);

    if (!price.express) price.express = 'FREE';
    else price.express = `$${price.express}`;

    if (!price.standard) price.standard = 'FREE';
    else price.standard = `$${price.standard}`;

    return price;
  }, [discountData.percent_off, isWhiteGlove]);

  return (
    <Grid container>
      <Grid item xs={12} md={12} style={{ height: '100%', padding: '0 3rem 0' }}>
        <div style={{ marginTop: '8px' }}>
          <RadioGroup onChange={handleUpdateSelectedPackage} value={selectedPackage}>
            <FormControlLabel
              control={<Radio color="primary" checked={selectedPackage === 'standard'} />}
              label={`Standard Package - Within 5 days - ${pricing.standard}`}
              value="standard"
              style={{ textAlign: 'left' }}
            />
            <FormControlLabel
              control={<Radio color="primary" checked={selectedPackage === 'express'} />}
              label={`Express Package - Within 48 hours - ${pricing.express}`}
              value="express"
              style={{ textAlign: 'left' }}
            />
          </RadioGroup>
        </div>
      </Grid>
    </Grid>
  );
};
